module.exports = require("core-js-pure/stable/map");